import React from "react";
import { Typography, StatusIndicator } from "components";

import "./style.scss";

const ChartCard = ({ label, record, img, color, percentage }) => {
  return (
    <div className="chart-card-container">
      <img src={img} alt="" />
      <div>
        <Typography variant="body3">{label}</Typography>
        <div className="mt-1 d-flex justify-content-between">
          <Typography variant="subtitle3">{record}</Typography>
          <div className="mt-3" style={{ height: "4rem", width: "4rem" }}>
            <StatusIndicator color={color} percentage={percentage} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartCard;
